import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-oauth',
  templateUrl: './oauth.component.html',
  styleUrls: ['./oauth.component.scss']
})
export class OauthComponent implements OnInit {

  constructor( private readonly authenticationService: AuthenticationService ) { }
  /**
   * initialize the oauth component
   */
  ngOnInit() {
    this.authenticationService.login();
  }

}
